import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    wrapperDialog: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    containerInputFiled: {
      display: "flex",
      flexDirection: "row",
      gap: "16px",
    },
    titleInputFiled: {
      fontSize: "14px",
      fontWeight: 600,
      color: theme.palette.text.secondary,
      maxWidth: "260px",
      minWidth: "180px",
      lineHeight: "20px",
    },
  };
});
